import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "./components/authentication/authentication/authentication.service";
import { ActivationEnd, Router, RouterEvent } from "@angular/router";
import { EnvironmentService } from "./environment/environment.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  title = "Competitor Product Database";
  authComplete = false;
  timer = 0;
  expireTime = 0;
  private appName: string;
  private environmentName: string;
  route: string;

  constructor(
    private authService: AuthenticationService,
    private readonly environmentService: EnvironmentService,
    private router: Router
  ) {
    // Enable Auth Silent Renew
    this.authService.enableSilentRenew();

    // Setup app info config.
    // tslint:disable-next-line:no-shadowed-variable
    const environment = this.environmentService.environment;
    this.appName = environment.appName || "";
    this.environmentName = environment.environmentName || "";

    router.events.subscribe((event: ActivationEnd) => {
      if (event instanceof ActivationEnd) {
        this.route = event.snapshot.url.toString().replace(",", "/");
      }
    });
  }

  ngOnInit(): void {
    //do nothing, leave this comment to avoid sonar error
  }
}
